import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctInt256, FctTimestamp, FctUInt80 } from '../../../../Fct/generics';
import { getPairs } from '../helpers/pairs';
export var LatestRoundData = createPlugin({
    protocol: 'CHAINLINK',
    type: 'ORACLE',
    method: 'latestRoundData',
    name: 'priceFeeds',
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'chainlink_datafeed', options: getPairs({ chainId: chainId }) }),
                methodParams: {},
            },
            output: {
                roundId: new FctUInt80({ innerIndex: 0 }),
                price: new FctInt256({ innerIndex: 1, destination: 'wei_amount' }),
                startedAt: new FctTimestamp({ innerIndex: 2 }),
                updatedAt: new FctTimestamp({ innerIndex: 3 }),
                answeredInRound: new FctUInt80({ innerIndex: 4 }),
            },
        });
    },
});
